export default __webpack_public_path__ + "static/media/Snd_o1.6fdf29bb.mp3";